import script from "./popup_aiorder_doc_print.vue?vue&type=script&setup=true&lang=js"
export * from "./popup_aiorder_doc_print.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__